/** Tolerant date formatting: the backend stores dates as plain strings in several shapes. */
export function formatDate(value) {
  if (!value) return '—';
  const d = new Date(typeof value === 'string' ? value.replace(' ', 'T') : value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
}

export const formatNumber = (n) => (typeof n === 'number' && Number.isFinite(n) ? n.toLocaleString() : '—');
